<template>
    <Toast />
    <div>
        <p class="profile-title">Channel Profile</p>
        <div class="card p-fluid invitation-card">
            <div class="invitation-container">
                <span class="invitation-label">ArenaCX Invitation URL for</span>
                <span class="channel-name">{{ channelName }}</span>
                <span class="invitation-label">:</span>
                <a :href="invitationUrl" target="_blank" class="invitation-url-link">{{ invitationUrl }}</a>
            </div>
            <div class="invitation-description">
                <p>Please use this URL to invite customers to your channel in the ArenaCX platform. Once your customer
                    creates a new user with this URL, all RFPs that they create will be assigned to this channel.</p>
            </div>
        </div>
        <div class="p-d-flex  p-jc-end">

            <div v-if="show">
                <Button label="Cancel" class="p-button-outlined button" @click="cancel" />
                <Button label="Save" class="button" @click="savePartnerProfile" />
                <FloatingSaveCancel @save="savePartnerProfile" @cancel="cancel" />
            </div>
        </div>

        <Accordion :activeIndex="0">
            <AccordionTab header="Basic information - Channel profile information">
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Company Name</p>
                        <InputText :disabled="disableEditForDifferentOrigin" type="text" v-model="v$.Company_name.$model" @input="inputChange()"
                            placeholder="Enter company name" @keypress="isLetter($event)" />
                        <p v-for="error of v$.Company_name.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the value' }}
                        </p>
                    </div>

                    <div class="p-col-12 p-md-6">
                        <p class="field-title">
                            Channel logo
                            <Tooltip
                                description="Recommended size 250*100px. Upload an image well suited for white/light backgrounds." />
                        </p>

                        <div v-if="logoUrl" class="logo-container">
                            <img :src="logoUrl" alt="Channel Logo" class="channel-logo" />
                            <i class="pi pi-times cross" @click="triggerDeleteFile = true"></i>

                        </div>

                        <div :style="{ visibility: logoUrl ? 'hidden' : 'visible' }">
                            <FileUpload :disabled="disableEditForDifferentOrigin" @saved="onSaved" :isImage="isImage" :isAttachment="isAttachment" :id="partnerId"
                                :fieldId="companyLogoName" :fieldName="company_logo" :logoUrl="logoUrl"
                                from="partnerProfile" v-model:triggerDeleteFile="triggerDeleteFile" />
                        </div>



                        <!-- <FileUpload @saved="onSaved" :isImage="isImage" :isAttachment="isAttachment" :id="partnerId"
                            :fieldId="companyLogoName" :fieldName="company_logo" :logoUrl="logoUrl" /> -->
                    </div>

                    <div class="p-col-12 p-md-6" v-if="isAdmin && platformName === 'ArenaCX'">
                        <p class="field-title">ArenaCX Quickbooks ID</p>
                        <InputText v-model="v$.Quickbooks_vendor_ID.$model" :disabled="disableEditForDifferentOrigin" @input="inputChange()"
                            placeholder="Enter ArenaCX Quickbooks ID" />
                        <p v-for="error of v$.Quickbooks_vendor_ID.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter numeric value of maximum length 15 characters' }}
                        </p>
                    </div>

                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Website</p>
                        <InputText type="text" v-model="v$.Website.$model" :disabled="disableEditForDifferentOrigin" @input="inputChange()"
                            placeholder="Enter Website" />
                        <p v-for="error of v$.Website.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter a valid URL' }}
                        </p>
                    </div>
                    <!-- <div class="p-col-12 p-md-6">
                        <p class="field-title">
                            Primary contact person
                            <Tooltip
                                description="This is the person at your firm best positioned to answer questions and make decisions during the RFQ and statement-of-work processes." />
                        </p>
                        <InputText type="text" v-model="v$.Primary_contact_person.$model" @input="inputChange()"
                            placeholder="Enter primary contact person" />
                        <p v-for="error of v$.Primary_contact_person.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the value' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Primary contact title</p>
                        <InputText type="text" v-model="v$.Primary_contact_title.$model" @input="inputChange()"
                            placeholder="Enter primary contact title" />
                        <p v-for="error of v$.Primary_contact_title.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the value' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Primary contact email</p>
                        <InputText type="text" v-model="v$.Primary_contact_email.$model" @input="inputChange()"
                            placeholder="Enter primary contact email" />
                        <p v-for="error of v$.Primary_contact_email.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the valid email' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Primary contact phone number</p>
                        <InputText type="text" v-model="v$.Phone_number.$model" @input="inputChange()"
                            placeholder="Enter primary contact phone number" @keypress="isNumber($event)" />
                        <p v-for="error of v$.Phone_number.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter a valid phone number' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">
                            Escalation contact name
                            <Tooltip
                                description="This is the person to whom we should bring issues, questions, and decisions if we are unable to reach the primary contact." />
                        </p>
                        <InputText type="text" v-model="v$.escalation_contact_name.$model" @input="inputChange()"
                            placeholder="Enter escalation contact name" />
                        <p v-for="error of v$.escalation_contact_name.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the value' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Escalation contact title</p>
                        <InputText type="text" v-model="v$.escalation_contact_title.$model" @input="inputChange()"
                            placeholder="Enter escalation contact title" />
                        <p v-for="error of v$.escalation_contact_title.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the value' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Escalation contact email</p>
                        <InputText type="text" v-model="v$.escalation_contact_email.$model" @input="inputChange()"
                            placeholder="Enter escalation contact email" />
                        <p v-for="error of v$.escalation_contact_email.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter the valid email' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Escalation phone number</p>
                        <InputText type="text" v-model="v$.escalation_contact_phone.$model" @input="inputChange()"
                            placeholder="Enter escalation phone number" @keypress="isNumber($event)" />
                        <p v-for="error of v$.escalation_contact_phone.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please enter a valid phone number' }}
                        </p>
                    </div> -->
                    <div class="p-col-12 p-md-6">
                        <p class="field-title">Year your organization was founded.
                        </p>
                        <InputText v-model="v$.business_countries.$model" :disabled="disableEditForDifferentOrigin" @input="inputChange()"
                            placeholder="Enter the year (1900-2200)" />
                        <p v-for="error of v$.business_countries.$errors" :key="error.$uid" class="error-msg">
                            {{ error.$validator === 'required' ? 'Please enter the year' : 
                               error.$validator === 'numeric' ? 'Please enter numeric value' :
                               error.$validator === 'yearRange' ? 'Year must be between 1900 and 2200' :
                               'Please enter a valid year' }}
                        </p>
                    </div>
                    <div class="p-col-12 p-md-6" v-if="isAdmin">
                        <p class="field-title">Please select directory access for this partner</p>

                        <MultiSelect v-model="v$.directory_access.$model" display="chip" :options="directoryOptions" :disabled="disableEditForDifferentOrigin"
                            @change="changeHandler" optionLabel="name" placeholder="Select Directory Access" />

                        <p v-for="error of v$.directory_access.$errors" :key="error.$uid" class="error-msg">
                            {{ 'Please select directory access' }}
                        </p>
                    </div>
                </div>
                <!-- <ProfileAddress :isChannel="false" :saveInd="saveInd" :locationInfoValues="locationInfoValues"
                    @submit="locationInfoValidation" /> -->

                <ProfileContacts :saveInd="saveInd" :contactValues="contactValues" @submit="contactValidation" :disableEditForDifferentOrigin="disableEditForDifferentOrigin" />

                <ProfileAddress :saveInd="saveInd" :locationInfoValues="locationInfoValues" :disableEditForDifferentOrigin="disableEditForDifferentOrigin"
                    @submit="locationInfoValidation" />

                <!-- <div class="p-grid p-fluid" v-if="isAdmin">
                    <div class="p-col-12 p-md-12 p-px-5">
                        <div class="field-title">Channels, Contract Templates and Channel Links</div>

                        <table class="channels-table">
                            <thead>
                                <tr>
                                    <th>Enable</th>
                                    <th>Channel Name</th>
                                    <th>Contract Template</th>
                                    <th>ArenaCX-branded Channel Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="channel in channels" :key="channel.subnetwork_id">
                                 
                                    <td class="switch-column">
                                        <InputSwitch v-model="channel.enabled" @change="toggleChannel(channel)" />
                                    </td>

                                  
                                    <td class="channel-name-column">
                                        {{ channel.name }}
                                    </td>

                                    <td class="template-column">
                                        <select v-model="channel.selectedTemplate" disabled class="template-dropdown"
                                            @change="changeHandler">
                                            <option :disabled="!channel.isContractTemplate" value="self">
                                                {{
                                                    channel.isContractTemplate
                                                        ? `${channel?.name} [Template Available]`
                                                        : `${channel?.name} [Template Unavailable]`
                                                }}
                                            </option>
                                            <option value="default">Default [ArenaCX]</option>
                                        </select>
                                    </td>

                                    <td class="channel-link-column">
                                        <a :href="`https://platform.arenacx.com/?ch=${channel.subnetwork_code}`"
                                            target="_blank">
                                            {{ `https://platform.arenacx.com/?ch=${channel.subnetwork_code}` }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script>
import { required, email, maxLength, minLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import ProfileService from '../../service/ProfileSservice';
import { onMounted } from '@vue/runtime-core';
import { getAccount, getAccountId, getIsChannel } from '../../service/common';
import Tooltip from '../Tooltip.vue';
import ProfileAddress from './ProfileAddress.vue';
import ProfileContacts from './ProfileContacts.vue';
import CountryService from '../../service/CountryService';
import FileUpload from '../common/FileUpload.vue';
import FloatingSaveCancel from '../common/FloatingSaveCancel.vue';
import { directoryOptions } from '../../service/common/directoryCode';
import AccountMangementService from '../../service/AccountManagementService';
import EventBus from '../../event-bus';

const customDomainCheck = (value) => {
    if (value) {
        //#31wdfdn -- decided this was always going to be a problem, so always return true.
        //            every regex variation has flaws
        return true;

        // PREVIOUS VERSION: didn't like any path, or ".outsourcing" vs ".com"
        // const regex = new RegExp(/(?:(?:[a-zA-Z0-9])(?:[-.][a-zA-Z0-9])?)+(?:\.[a-z]{2,6})+$/);
        // return regex.test(value);
    }
    return true;
};

const positiveInt = (value) => {
    if (value && (value.length > 15 || value < 0 || !/^[1-9]\d*$/.test(value))) return false;
    else return true;
};

export default {
    components: {
        ProfileAddress,
        Tooltip,
        FileUpload,
        FloatingSaveCancel,
        ProfileContacts,
    },
    data() {
        return {
            Company_name: null,
            Quickbooks_vendor_ID: null,
            Website: '',
            Primary_contact_person: '',
            Primary_contact_title: '',
            Primary_contact_email: '',
            escalation_contact_name: '',
            escalation_contact_title: '',
            escalation_contact_email: '',
            escalation_contact_phone: '',
            business_countries: null,
            directory_access: [],
            Phone_number: null,
            companyLogoName: '',
            profileForm: {},
            responseData: [],
            show: false,
            isAdmin: false,
            isImage: true,
            isAttachment: false,
            partnerId: null,
            locationInfoValues: null,
            saveInd: false,
            countries: null,
            logoUrl: null,
            mappedCountry: [],
            fileName: null,
            deleteFile: false,
            directoryOptions: directoryOptions,
            channels: [],
            partnerChannels: [],
            isChannel: false,
            channelName: null,
            invitationUrl: null,
            marketplaceUser: null,
            triggerDeleteFile: false,
            DEFAULT_CHANNEL_SUBNETWORK_ID: "f4cd7264-3f00-463b-b2e9-d9e69c3ec193",
            isDefaultChannel: false,
            disableEditForDifferentOrigin: false,
            platformName: process.env.VUE_APP_PLATFORM_NAME
        };
    },
    setup() {
        return { v$: useVuelidate() };
    },
    validations() {
        return {
            Company_name: { required, $autoDirty: true },
            Quickbooks_vendor_ID: (this.isAdmin && this.platformName === 'ArenaCX') ? { positiveInt } : {},
            Website: { customDomainCheck },
            Primary_contact_person: { $autoDirty: true },
            Primary_contact_title: { $autoDirty: true },
            Primary_contact_email: { email, $autoDirty: true },
            escalation_contact_name: { $autoDirty: true },
            escalation_contact_title: { $autoDirty: true },
            escalation_contact_email: { email, $autoDirty: true },
            escalation_contact_phone: { maxLength: maxLength(25), minLength: minLength(10), $autoDirty: true },
            business_countries: { 
                $autoDirty: true, 
                positiveInt,
                yearRange: (value) => {
                    if (!value) return true; // Let required validation handle empty values
                    const year = parseInt(value);
                    return !isNaN(year) && year >= 1900 && year <= 2200;
                }
            },
            directory_access: this.isAdmin ? { $autoDirty: true, required } : {},
            Phone_number: { maxLength: maxLength(15), minLength: minLength(10) },
        };
    },
    created() {
        this.profileService = new ProfileService();
        this.countryService = new CountryService();
        this.accountMangementService = new AccountMangementService();
        this.isChannel = getIsChannel();
        onMounted(async() => {
            this.getProfile();
            this.marketplaceUser = JSON.parse(localStorage.getItem('pro_marketplaceUser'));
            this.isAdmin = getAccount();
            this.countryService.getCountries().then((countries) => {
                this.countries = countries;
            });

          await this.fetchChannels()
        });
    },
    watch: {
        $route() {
            this.partnerId = getAccountId();
        },
        partnerId() {
            this.profileService = new ProfileService();
            this.getProfile();
            this.isAdmin = getAccount();
        },
    },
    methods: {
        onSaved(file) {
            this.logoUrl = file;
        },

        contactValidation(silentErrors, contactValuesData) {
            // Check if there's at least one primary contact
            const hasPrimaryContact = contactValuesData.some(contact => contact.isPrimary);
            this.contactValues = contactValuesData;
            this.contactsValid = !silentErrors && hasPrimaryContact;
            this.inputChange();
        },


        toggleChannel(ch) {
            if (!ch.enabled) {
                ch.selectedTemplate = 'default';
            }
            this.show = true;
        },
        changeHandler() {
            this.show = true;
        },
        savePartnerProfile() {
            this.v$.$touch();

            // Set saveInd to true to trigger child component validation
            this.saveInd = true;

            // Use nextTick to ensure child components have time to validate
            this.$nextTick(() => {

                // Check for at least one primary contact
                const hasPrimaryContact = this.contactValues && this.contactValues.some(contact => contact.isPrimary);
                if (!hasPrimaryContact) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'At least one primary contact is required',
                        life: 3000,
                    });
                    this.saveInd = false;
                    return;
                }

                if (this.v$.$error === false) {
                    this.submitProfile();
                } else {
                    this.v$.$errors.forEach((d) => {
                        if (d.$property === 'Company_name') {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error while creating user',
                                detail: 'Please update mandatory field',
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error while creating user',
                                detail: 'Please enter a valid input',
                                life: 3000,
                            });
                        }
                    });
                }

                // Reset saveInd after validation
                this.saveInd = false;
            });
        },
        locationInfoValidation(silentErrors, locationInfoValuesData) {
            this.locationInfoValues = locationInfoValuesData;
            this.inputChange();
        },
        stringCheck(value) {
            if (value !== null && value !== undefined) {
                return value.toString().trim();
            }
        },
        inputChange() {
            this.show = true;
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if (!/[^a-zA-Z0-9 ,.]/.test(char)) return true;
            else e.preventDefault();
        },
        isNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (!/[^0-9+]/.test(char)) return true;
            else e.preventDefault();
        },
        phoneKeyUp() {
            if (this.escalation_contact_phone !== '' || this.Phone_number !== '') {
                this.show = true;
            }
        },
        submitProfile() {
            this.show = false;
            let payload = {};
            var filteredData = this.responseData.filter((element) => {
                if (element.field_name !== 'company_logo') {
                    return element;
                }
            });

            filteredData.forEach((element) => {
                if (element.field_name == 'name') {
                    element.json_value = this.stringCheck(this.Company_name);
                    this.Company_name = this.stringCheck(this.Company_name);
                }
                if (element.field_name == 'website') {
                    element.json_value = this.Website;
                }
                if (element.field_name == 'quickbooks_vendor_id' && this.isAdmin) {
                    element.json_value = this.Quickbooks_vendor_ID;
                }
                if (element.field_name == 'phone') {
                    element.json_value = this.Phone_number;
                }
                if (element.field_name == 'primary_contact_name') {
                    element.json_value = this.stringCheck(this.Primary_contact_person);
                    this.Primary_contact_person = this.stringCheck(this.Primary_contact_person);
                }
                if (element.field_name == 'primary_contact_title') {
                    element.json_value = this.stringCheck(this.Primary_contact_title);
                    this.Primary_contact_title = this.stringCheck(this.Primary_contact_title);
                }
                if (element.field_name == 'email') {
                    element.json_value = this.Primary_contact_email;
                }
                if (element.field_name == 'escalation_phone_number') {
                    element.json_value = this.escalation_contact_phone;
                }
                if (element.field_name == 'escalation_contact_name') {
                    element.json_value = this.stringCheck(this.escalation_contact_name);
                    this.escalation_contact_name = this.stringCheck(this.escalation_contact_name);
                }
                if (element.field_name == 'escalation_contact_email') {
                    element.json_value = this.escalation_contact_email;
                }
                if (element.field_name == 'escalation_contact_title') {
                    element.json_value = this.stringCheck(this.escalation_contact_title);
                    this.escalation_contact_title = this.stringCheck(this.escalation_contact_title);
                }
                if (element.field_name == 'locations') {
                    this.locationInfoValues?.forEach((ele) => delete ele.countryName);
                    element.json_value = this.locationInfoValues;
                }
                if (element.field_name == 'contacts') {
                    element.json_value = this.contactValues;
                }
                if (element.field_name == 'business_years') {
                    element.json_value = parseInt(this.business_countries);
                }
                if (element.field_name == 'directory_access' && this.isAdmin) {
                    element.json_value = this.directory_access.map((item) => item.code);
                }
            });

            filteredData.forEach((ele) => {
                payload[ele.id] = ele.json_value === undefined ? null : ele.json_value;
            });
            payload.channels = this.channels
                .filter((e) => e.enabled)
                .map((channel) => {
                    return {
                        subnetwork_id: channel.subnetwork_id,
                        contract_subnetwork:
                            channel.selectedTemplate === 'default'
                                ? 'f4cd7264-3f00-463b-b2e9-d9e69c3ec193'
                                : channel.subnetwork_id,
                    };
                });
            this.profileService.updateProfile(payload).then((res) => {
                if (res.status === 200) {
                    this.show = false;
                    this.$toast.add({ severity: 'success', summary: res.data.data, detail: '', life: 3000 });
                    // Refetch channels after successful save
                    this.fetchChannels();
                    // Menu refresh not needed - profile updates don't affect menu structure
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error while creating user', detail: res.data, life: 3000 });
                }
            });
        },
        cancel() {
            this.getProfile();
            this.show = false;
        },
        
        async fetchChannels() {
            try {
                const res = await this.accountMangementService.getChannels();
                this.channels = res.data.data;
                
                const subnetworkId = this.isAdmin ? localStorage.getItem('subnetworkId') : this.marketplaceUser?.value?.subnetworkId;
                
                this.isDefaultChannel = subnetworkId === this.DEFAULT_CHANNEL_SUBNETWORK_ID;
                const channelCode = this.channels.find(channel => channel.subnetwork_id === subnetworkId)?.subnetwork_code;
                this.channelName = this.channels.find(channel => channel.subnetwork_id === subnetworkId)?.name;
                this.invitationUrl = this.isDefaultChannel ? `${process.env.VUE_APP_RFPERFECT_FRONTEND_URL}` : `${process.env.VUE_APP_RFPERFECT_FRONTEND_URL}?ch=${channelCode}`;
            } catch (error) {
                console.error('Error fetching channels:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error fetching channels',
                    detail: error.message,
                    life: 3000,
                });
            }
        },
        async getProfile() {
            var data = await this.profileService.getProfileById();
            if (data.status === 200) {
                var resData = data.data.data.data[0].data;
                this.partnerChannels = data.data.data.channels;
                const defaultSubnetworkId = 'f4cd7264-3f00-463b-b2e9-d9e69c3ec193';
                //promise. all to fetch the if the contract template exists in partnerchannels

                this.channels = this.channels
                    .map((channel) => {
                        const partnerCh = this.partnerChannels.find(
                            (partnerChannel) => partnerChannel.subnetwork_id === channel.subnetwork_id
                        );

                        // Default values for channel properties
                        const updatedChannel = {
                            ...channel,
                            isContractTemplate: false, // Initial default value
                            enabled: partnerCh?.subnetwork_id === channel?.subnetwork_id || false,
                            selectedTemplate:
                                partnerCh?.contract_subnetwork === defaultSubnetworkId || !partnerCh?.contract_subnetwork
                                    ? 'default'
                                    : 'self',
                        };

                        // Asynchronously update isContractTemplate without waiting
                        this.accountMangementService
                            .getContractTemplate(channel.subnetwork_id)
                            .then((resp) => {
                                const templateExists = resp.data.data.templateExists;
                                console.log('templateExists:', templateExists);

                                // Update the isContractTemplate field
                                updatedChannel.isContractTemplate = templateExists;

                                // Update this.channels with the modified channel object
                                this.channels = this.channels.map((ch) =>
                                    ch.subnetwork_id === channel.subnetwork_id ? updatedChannel : ch
                                );
                            })
                            .catch((error) => {
                                console.error('Error fetching contract template:', error);
                            });

                        return updatedChannel;
                    })
                    .sort((a, b) => {
                        if (a.subnetwork_id === defaultSubnetworkId) {
                            return -1;
                        }
                        return 1;
                    });

                //enabled is true if its present in this.partnerchannels

                resData.forEach((element) => {
                    // 8685m4xxm -- weird newline characters at end of emails causing validation trouble
                    if (typeof element.json_value === 'string') {
                        element.json_value = element.json_value.trim(); // trim() does everything!
                    }

                    if (element.json_value === 'null') {
                        element.json_value = null;
                    }

                    if (element.field_name == 'name') {
                        this.Company_name = element.json_value;
                    }
                    if (element.field_name == 'website') {
                        this.Website = element.json_value;
                    }
                    if (element.field_name == 'quickbooks_vendor_id' && this.isAdmin) {
                        this.Quickbooks_vendor_ID = element.json_value;
                    }
                    if (element.field_name == 'phone') {
                        this.Phone_number = element.json_value;
                    }
                    if (element.field_name == 'primary_contact_name') {
                        this.Primary_contact_person = element.json_value;
                    }
                    if (element.field_name == 'primary_contact_title') {
                        this.Primary_contact_title = element.json_value;
                    }
                    if (element.field_name == 'email') {
                        this.Primary_contact_email = element.json_value;
                    }
                    if (element.field_name == 'escalation_phone_number') {
                        this.escalation_contact_phone = element.json_value;
                    }
                    if (element.field_name == 'escalation_contact_name') {
                        this.escalation_contact_name = element.json_value;
                    }
                    if (element.field_name == 'escalation_contact_email') {
                        this.escalation_contact_email = element.json_value;
                    }
                    if (element.field_name == 'escalation_contact_title') {
                        this.escalation_contact_title = element.json_value;
                    }
                    if (element.field_name == 'locations') {
                        this.locationInfoValues = element.json_value;
                    }
                    if (element.field_name == 'contacts') {
                        this.contactValues = element.json_value;
                    }
                    if (element.field_name == 'business_years') {
                        this.business_countries = element.json_value;
                    }
                    if (element.field_name == 'company_logo') {
                        this.companyLogoName = element.id;
                        this.partnerId = getAccountId();
                        this.logoUrl = element?.other?.attachments[0] || null;
                        if (this.logoUrl) {
                            var splitLink = this.logoUrl?.split('/');
                            this.fileName = splitLink[splitLink.length - 1];
                        }
                    }
                    if (element.field_name == 'directory_access' && this.isAdmin) {
                        this.directory_access =
                            Array.isArray(element.json_value) && element.json_value.length > 0
                                ? element.json_value.map((code) => {
                                    return this.directoryOptions.find((option) => option.code === code);
                                }).filter((option) => option !== undefined) // Filter out undefined options
                                : [];
                    }
                });
                //data.data.data.channels contains the channels data name, subnetwork_id.With
                return (this.responseData = resData);
            } else {
                (this.Company_name = ''),
                    (this.Quickbooks_vendor_ID = ''),
                    (this.Website = ''),
                    (this.Primary_contact_name = ''),
                    (this.Phone_number = '');
            }
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep(.p-multiselect) {
    margin-left: 1rem;
    max-width: 30rem;
}

.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.uploadButton {
    display: none;
}

.uploadLabel {
    border: 1px solid #949ba1;
    display: inline-block;
    padding: 10px;
    cursor: pointer;
    border-radius: 5px;
    background-color: transparent;
    color: rgb(109, 107, 107);
    width: 30rem;
    margin-left: 1rem;
    background-image: url('../../assets/Upload.svg');
    background-position: 95% center;
    background-repeat: no-repeat;
}

::v-deep(.p-accordion-header) {
    font-size: large;
}

::v-deep(.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link),
::v-deep(.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link):hover {
    background-color: rgb(228, 228, 228);
    font-weight: 500;
    margin-top: 1rem;
}

::v-deep(.eden-color) {
    background: #0f5b60;
}

::v-deep(.p-button) {
    background: #00796b !important;
    width: 8rem !important;
    border: 2px solid #00796b !important;
}

::v-deep(.p-button.p-button-outlined) {
    background-color: transparent !important;
    color: #00796b !important;
    border: 1px solid;
    margin-right: 1.25rem;
}

.profile-title {
    font-weight: 700;
    font-family: 'Prompt', sans-serif;
    font-size: 27px;
    margin-left: 1rem;
}

::v-deep(.p-inputtext) {
    margin-left: 1rem;
    max-width: 30rem;
}

.field-title {
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    max-width: 30rem;
    margin-bottom: 1.5rem;
}

.error-msg {
    margin-left: 1.25rem;
    color: red;
    font-size: 1rem;
    font-weight: 400;
}

.link {
    position: relative;
    left: 1.5rem;
    top: 0.5rem;
    cursor: pointer;
}

.link a {
    color: blue;
}

.attach-file {
    color: #126a70;
    margin-left: 3rem;
}

/* Table styles */
.channels-table {
    width: 100%;
    border-collapse: collapse;
    margin-left: 10px;
    margin-top: 10px;
}

.channels-table th,
.channels-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

/* Column styles */
.switch-column {
    width: 10%;
}

.channel-name-column {
    width: 20%;
    font-size: 14px;
}

.template-column {
    width: 20%;
}

.channel-link-column {
    width: 40%;
}

/* Dropdown styles */
/* Ensure the dropdown fills the cell */
.template-dropdown {
    width: 100%;
    padding: 5px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    box-sizing: border-box;
}

/* Style when dropdown is focused (active state) */
.template-dropdown:focus {
    outline: none;
    border-color: #007bff;
    /* Add blue border on focus */
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    /* Subtle blue glow effect */
    background-color: white;
    /* Keep background white on focus */
    color: black;
    /* Ensure text color is black */
}

/* Change the caret (dropdown arrow) color if needed */
.template-dropdown::-ms-expand {
    color: black;
}

/* Optional - Style hover and active states for better UX */
.template-dropdown:hover {
    border-color: #007bff;
    /* Blue border on hover */
}

.template-dropdown:active {
    border-color: #007bff;
}

.channels-table th {
    font-weight: 400;
}

.template-dropdown option {
    border-radius: 0px;
    /* Remove any border-radius on the expanded options */
    background-color: white;
    color: black;
}

/* Customize the dropdown open list */
.template-dropdown:focus option {
    border-radius: 0px;
    /* Ensure no rounded corners for the dropdown list */
    background-color: white;
    color: black;
}


.invitation-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.invitation-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.invitation-label {
    font-size: 1.2rem;
    color: #495057;
}

.channel-name {
    font-size: 1.2rem;
    font-weight: 600;
    color: #495057;

}

.invitation-url-link {
    color: #2196F3;
    text-decoration: none;
    word-break: break-all;

    &:hover {
        text-decoration: underline;
        color: #1976D2;
    }
}

.invitation-description {
    font-size: 1rem;
    font-weight: 400;
    color: #495057;
}

.channel-logo {
    margin-bottom: 1rem;
    margin-left: 1rem;
    height: 60px;
    object-fit: cover;
}

.logo-container {
    position: relative;
}

.cross {
    cursor: pointer !important;
    margin-left: 0.5rem;
    position: absolute;
}
</style>
